module.exports = __webpack_public_path__ + "img/carousel.84e7a322.png";